import { render, staticRenderFns } from "./KButtonGroup.vue?vue&type=template&id=1011b8a6&scoped=true&lang=pug"
import script from "./KButtonGroup.vue?vue&type=script&lang=js"
export * from "./KButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./KButtonGroup.vue?vue&type=style&index=0&id=1011b8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1011b8a6",
  null
  
)

export default component.exports